export default __webpack_public_path__ + "static/media/info_blue_filled.9035f469.svg";